(function () {
  'use strict';
  var busy = false;
  function messages() { var node = document.getElementById('BFFJourneyText'); return node ? JSON.parse(node.textContent) : {}; }
  function fail(form, message) {
    var box = form.querySelector('[data-bff-journey-error]');
    if (!box) { box = document.createElement('p'); box.className = 'bff-journey-error'; box.dataset.bffJourneyError = ''; box.setAttribute('role', 'alert'); form.appendChild(box); }
    box.textContent = message;
    var link = document.createElement('a'); link.href = (window.Shopify.routes.root || '/') + 'cart'; link.textContent = messages().review; box.appendChild(document.createTextNode(' ')); box.appendChild(link);
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]') || !form.closest('product-info') || !form.closest('.m-product-form--main')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    var area = form.closest('product-info'), core = window.BFFJourneyCore, words = messages();
    if (!core || !form.reportValidity()) return;
    var fd = new FormData(form), properties = {}, extras = [], picker = area.querySelector('[data-bff-extras]');
    fd.forEach(function (value, name) { var match = /^properties\[(.+)\]$/.exec(name); if (match && typeof value === 'string' && value.trim() && match[1].indexOf('_bff_') !== 0) properties[match[1]] = value; });
    if (window.BFFCheckoutPrefill) window.BFFCheckoutPrefill.remember(properties['Order type'] === 'Pickup at store' ? '' : properties['Delivery ZIP']);
    var dateValue = properties['Pickup date'] || properties['Preferred delivery date'];
    if (dateValue && (dateValue < core.earliest(properties['Order type'] === 'Pickup at store' ? 'pickup' : 'delivery') || core.sunday(dateValue))) {
      var dateField = area.querySelector('[data-bff-date]');
      if (dateField) { dateField.min = core.earliest(properties['Order type'] === 'Pickup at store' ? 'pickup' : 'delivery'); dateField.value = ''; dateField.focus(); dateField.reportValidity(); }
      return;
    }
    if (picker) {
      var tier = area.querySelector('[data-bff-tier-variant]:checked');
      if (tier && tier.dataset.bffTierVariant) extras.push(tier.dataset.bffTierVariant);
      picker.querySelectorAll('[data-bff-addon]:checked').forEach(function (input) { extras.push(input.dataset.variantId); });
    }
    var items;
    try { items = core.selectedItems({ id: fd.get('id'), quantity: Number(fd.get('quantity') || 1), properties: properties }, extras, 'j' + Date.now().toString(36) + Math.random().toString(36).slice(2, 9), picker ? picker.dataset.parentTitle : document.title); }
    catch (error) { fail(form, words.unavailable); return; }
    var plan = fd.get('selling_plan'); if (plan) items[0].selling_plan = Number(plan);
    busy = true;
    var buttons = Array.from(form.querySelectorAll('button[type="submit"]')), states = buttons.map(function (button) { return button.disabled; });
    buttons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    var previous = form.querySelector('[data-bff-journey-error]'); if (previous) previous.remove();
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 25000);
    try {
      var route = window.Shopify.routes.root || '/';
      // The latest explicit product choice must replace stale cart fulfillment attributes.
      // Save before adding so a failed sync cannot cause duplicate items on retry.
      if (properties['Order type']) {
        var pickup = properties['Order type'] === 'Pickup at store';
        var attributes = { 'Order type': properties['Order type'],
          'Pickup date': pickup ? (dateValue || '') : '',
          'Preferred delivery date': pickup ? '' : (dateValue || ''),
          'Pickup time': pickup ? (properties['Pickup time'] || '') : '',
          'Preferred delivery time': pickup ? '' : (properties['Preferred delivery time'] || 'Anytime'),
          'Delivery ZIP': pickup ? '' : (properties['Delivery ZIP'] || '') };
        // A newly entered message must also prefill the order-level cart form.
        // An empty product field must not erase a message already saved in the cart.
        if (properties['Card message']) attributes['Card message'] = properties['Card message'];
        var savedResponse = await fetch(route + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attributes }), signal: controller.signal });
        var savedCart = await savedResponse.json();
        if (!savedResponse.ok || !savedCart.attributes || savedCart.attributes['Order type'] !== attributes['Order type']) throw new Error('fulfillment-not-saved');
        if (properties['Card message'] && savedCart.attributes['Card message'] !== properties['Card message']) throw new Error('card-message-not-saved');
      }
      var response = await fetch(route + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }), signal: controller.signal });
      var result = await response.json();
      if (!response.ok || !Array.isArray(result.items) || result.items.length !== items.length) throw new Error('selection-not-confirmed');
      var requested = items.every(function (item) { return result.items.some(function (added) { return Number(added.variant_id || added.id) === item.id && Number(added.quantity) === item.quantity && added.properties && added.properties._bff_group === item.properties._bff_group; }); });
      if (!requested) throw new Error('selection-mismatch');
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result.items[0] } }));
      if (extras.length) document.dispatchEvent(new CustomEvent('bff:extras:added'));
      window.location.assign(route + 'cart');
    } catch (error) {
      document.dispatchEvent(new CustomEvent('product-ajax:error'));
      fail(form, words.error);
    } finally {
      clearTimeout(timeout); busy = false;
      buttons.forEach(function (button, index) { button.disabled = states[index]; button.removeAttribute('aria-busy'); });
    }
  }, true);
})();

